// extracted by mini-css-extract-plugin
export var filterIncDec = "_3b-0";
export var leftBorder = "_3b-1";
export var rightBorder = "_3b-2";
export var stringInput = "_3b-3";